<template>
  <span class="team-tag">
    <router-link :to="`/teams/${activeTeam.id}`">
      <b-tag
        type="is-light"
        rounded
        class="has-text-weight-normal"
      >
        {{ activeTeam.teamName }}
      </b-tag>
    </router-link>
  </span>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'TeamTag',

  props: {
    teamId: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState({
      teams: state => state.team.teams,
    }),
    activeTeam() {
      return this.teams[this.teamId];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
